export enum State { '禁用', '启用', '未知' };
export enum Stage { never, '测试阶段', '已上线' };
export enum AuthType { '未认证', '个人认证', '公司认证' };
export enum AppState { '禁用', '可用' };